/* eslint no-underscore-dangle: [error, { allow: [_id] }] */
import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import MatchesStore from '../../stores/MatchesStore';
import ImageSvg from '../image/ImageSvg';
import MemberLink from '../member/MemberLink';
import MemberImage from '../member/MemberImage';
import MemberName from '../member/MemberName';
import VerificationBadge from '../verification/VerificationBadge';
import confetti from '../../../../libraries/confetti/index';
import ConversationActionCreators from '../../actions/ConversationActionCreators';
import MessageComposer from '../../../legacy/flux/components/messages/MessageComposer.react';
import CloseIcon from '../../../legacy/flux/components/misc/CloseIcon.react';

class NewMatch extends Component {
  state = {
    newMatch: null,
    showMessagesSection: false,
    newMatchMessageStatus: null,
    newMatchMessageError: null,
  };

  componentDidMount() {
    MatchesStore.addChangeListener(this.onChange);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.newMatch || this.state.newMatch === prevState.newMatch) {
      return;
    }

    confetti.init();
  }

  componentWillUnmount() {
    MatchesStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    let newMatch = MatchesStore.getNewMatch();

    if (newMatch && (!Object.prototype.hasOwnProperty.call(newMatch, 'me') || !Object.prototype.hasOwnProperty.call(newMatch, 'member'))) {
      newMatch = null;
    }

    this.setState({
      newMatch,
      newMatchMessageStatus: MatchesStore.getNewMatchMessageStatus(),
      newMatchMessageError: MatchesStore.getNewMatchMessageError(),
    });
  };

  onClose = () => {
    this.setState({
      showMessagesSection: false,
    });

    MatchesStore.setNewMatch(null);
    MatchesStore.setNewMatchMessageStatus(null),
    MatchesStore.setNewMatchMessageError(null),
    MatchesStore.setSearchMember(null);
    MatchesStore.emitChange();
  };

  toggleMessagesSection = (e) => {
    e.preventDefault();

    this.setState({ showMessagesSection: !this.state.showMessagesSection });
  };

  onMessageSubmit = (text) => {
    const { newMatch } = this.state;

    MatchesStore.setNewMatchMessageStatus('loading');
    MatchesStore.setNewMatchMessageError(null);
    MatchesStore.emitChange();

    ConversationActionCreators.createNewMatchMessage(text, newMatch.member._id, true);
  };

  onChangeEnter = (e) => {
    // e.preventDefault();

    console.logText('onChangeEnter', 'purple');
  };

  render() {
    const {
      newMatch,
      showMessagesSection,
      newMatchMessageStatus,
      newMatchMessageError,
    } = this.state;

    if (!newMatch) {
      return (null);
    }

    const messageSection = () => {
      if (!showMessagesSection) {
        return (
          <a
            href={`/member/${newMatch.member._id}`}
            className="btn btn--a btn--iconLeft mbm"
            onClick={this.toggleMessagesSection}
          >
            <span className="btn-static">
              <ImageSvg svg="icon-plane" iconClass="icon--center icon--planeBig" />
            </span>
            <span className="btn-text">Nosūtīt ziņu</span>
          </a>
        );
      }

      //
      let containerClass = 'matches-new-match-message por pbm ptm tal';

      //
      if (newMatchMessageStatus === 'success') {
        return (
          <div className={containerClass}>
            <div className="flash-inner success plm prm tac twsnw">
              <div className="flash-icon">
                <ImageSvg svg="icon-check-2" iconClass="icon--full icon--check-2" />
              </div>
              <div className="flash-content tal twb mbxs">
                Ziņa nosūtīta!
              </div>
            </div>
          </div>
        );
      }

      //
      if (newMatchMessageStatus === 'loading') {
        containerClass += ' loading';
      }

      //
      return (
        <div className={containerClass}>
          {newMatchMessageStatus === 'loading' && (
            <div className="loading-spinner loading-spinner--vcenter" />
          )}
          <div>
            <MessageComposer
              senderId={newMatch.me._id}
              showArrow={false}
              showSubscription={false}
              showGiphy={false}
              showImgUpload={false}
              smallInput
              transparent
              disableResize
              onMessageSubmit={this.onMessageSubmit}
              onChangeEnter={this.onChangeEnter}
              submitOnEnter={false/* this.state.submitOnEnter */}
              inPopup
            />
            <div className="poa abst absr mrxs">
              <CloseIcon onClick={this.toggleMessagesSection} />
            </div>
            {newMatchMessageStatus === 'error' && (
              <div className="flash-inner error plm prm tac twsnw">
                <div className="flash-icon">
                  <ImageSvg svg="icon-warning" iconClass="icon--full icon--warning" />
                </div>
                <div className="flash-content tal">
                  {newMatchMessageError}
                </div>
              </div>
            )}
          </div>
        </div>
      );
    };

    //
    return (
      <div className="matches-new-match vex vex-theme-default">
        <div className="vex-overlay" />
        <div className="vex-content tac">
          <canvas id="confetti" className="confetti" width="1" height="1" />
          <div className="por mts mbxs twb tsl">Tev ir jauna saderība! 💙</div>
          <div className="por mtxs mbs">Jūs viens otram patīkat :) Laiks uzsākt sarunu!</div>
          <div className="por pbs">
            <div className="matches-new-match-member dib vat mas">
              <MemberLink
                member={newMatch.me}
                memberId={newMatch.me._id}
                linkClass="tcb"
              >
                <MemberImage
                  member={newMatch.me}
                  memberId={newMatch.me._id}
                  type="o-m"
                  hideIcons
                  hideOnline
                  hidehHighlighted
                />
                <MemberName
                  member={newMatch.me}
                  memberId={newMatch.me._id}
                  className="dib mtxs"
                />
              </MemberLink>
              {newMatch.me.verified && (
                <VerificationBadge />
              )}
            </div>
            <div className="matches-new-match-member dib vat mas">
              <MemberLink
                member={newMatch.member}
                memberId={newMatch.member._id}
                linkClass="tcb"
              >
                <MemberImage
                  member={newMatch.member}
                  memberId={newMatch.member._id}
                  type="o-m"
                  hideIcons
                  hideOnline
                  hidehHighlighted
                />
                <MemberName
                  member={newMatch.member}
                  memberId={newMatch.member._id}
                  className="dib mtxs"
                />
              </MemberLink>
              {newMatch.member.verified && (
                <VerificationBadge />
              )}
            </div>
          </div>
          {messageSection()}
          <div
            className="vex-close"
            role="button"
            tabIndex="0"
            onClick={this.onClose}
            onKeyDown={this.onClose}
          />
        </div>
      </div>
    );
  }
}

export default NewMatch;
